/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios";
import { decode } from "jsonwebtoken";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getCompanyToken } from "../../apis/auth";
import { getAdditionalInfos } from "../../apis/companies/company-infos";
import { createContracts, getContracts } from "../../apis/contract";
import { CONTRACT_TYPE, SIGN_TEXT } from "../../constants/CONTRACT";
import useForm from "../../hooks/useForm";
import { contractListReload } from "../../store/actions";
import { dateToFormat, getDay } from "../../utils/date";
import { isEmpty } from "../../utils/lodashExtend";
import systemAlert from "../../utils/systemAlert";
import { toast } from "../../utils/toast";
import { translation } from "../../utils/translator";
import Badge from "../Badge";
import Button from "../Button";
import Editor from "../Editor";
import SunEditor from "../SunEditor";
import Form from "../Form";
import { getStoreEmployees } from "../../store/actions";
import { toDataURL } from "../../utils/image";
import ContractSign from "./ContractSign";
import { isNumber } from "../../utils/validator";
import { getEditorTemplate } from "../../apis/editorTemplate";

const Contract = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { employees } = useSelector((store) => ({
    employees: store.Data.employees,
  }));
  const {
    type,
    close,
    mode = "create",
    target: _target,
    contractIdx,
    submit: _submit,
    templateIdx,
  } = props;

  const [html, setHtml] = useState(null);
  const [defaultValue, setDefaultValue] = useState(null);
  const [fields] = useState([
    {
      title: "계약기간",
      key: "date",
      type: "customdatepicker",
      required: true,
    },
  ]);
  const [target, setTarget] = useState(null);
  const [isSigned, setIsSigned] = useState(false);
  const [contract, setContract] = useState(null);
  const [isOldEditor, setIsOldEditor] = useState(false);
  const [signBase64, setSignBase64] = useState("");
  const [signEmployeeOpen, setSignEmployeeOpen] = useState(false);
  const [title, setTitle] = useState(undefined);
  const token = getCompanyToken();
  const me = decode(token);

  useEffect(() => {
    if (mode === "detail" && contractIdx && !isEmpty(employees)) {
      getContract();
    }
  }, [mode, contractIdx, employees]);



  const getContract = () => {
    getContracts(contractIdx).then((res) => {
      const { startTime, endTime, html, targetEmployeeIdx, title } = res.data;

      setTitle(title);
      setContract(res.data);
      setForm({
        date: [dateToFormat(startTime), dateToFormat(endTime)],
      });
      const target = employees.find((e) => e.idx === targetEmployeeIdx);
      setTarget(target);
      setIsSigned(res.data.isSigned);

      setDefaultValue(html);
    });
  };
  useEffect(() => {
    setIsOldEditor(contract && contract.createdTime && contract.createdTime < '2023-09-09');
  }, [contract]);

  useEffect(() => {
    // TODO type에 따라 quill html 세팅...
    if (mode === "create" && type && history) {
      const fileUrl = `/contracts/${type}.html`;

      (type === "customContract" && isNumber(templateIdx) && templateIdx > 0
        ? getEditorTemplate(templateIdx)
        : Axios.get(fileUrl))
        .then((res) => {
          const signPosition = [];
          const data = res.content || res.data;
          !isEmpty(res.title) && setTitle(res.title);
          let pos = 0;
          while (true) {
            let foundPos = data.indexOf(SIGN_TEXT, pos);
            if (foundPos === -1) break;
            signPosition.push(foundPos);
            pos = foundPos + 1;
          }

          if (signPosition.length === 2) {
            getAdditionalInfos(2).then((res) => {
              const companySignList = res.data.additionalInfos;

              const companySign = companySignList.find(
                (sign) => sign.available === 1
              );
              if (isEmpty(companySignList)) {
                _close();
                toast.error(
                  "회사에 동륵된 인감정보가 없습니다. 먼저 등록해주세요."
                );
                // history.push('/manager/company-info?tab=addtional-info')
              } else if (!companySign) {
                _close();
                toast.error(
                  "공개된 인감정보가 없습니다. 회사 인감정보를 확인해주세요."
                );
              } else {
                let fileUrl = companySign.file.url;
                toDataURL(fileUrl, (data) => {
                  setSignBase64(data);
                });

                // 이미지의 s3 sign 부분 제거 START
                const startSignTextIdx = fileUrl.indexOf("?X-Amz-Algorithm");
                if (startSignTextIdx > -1) {
                  fileUrl = fileUrl.slice(0, startSignTextIdx);
                }
                // 이미지의 s3 sign 부분 제거 END
                let img = new Image();
                img.src = signBase64 || fileUrl;
                img.alt = companySign.title;
                img.width = 60;
                img.height = 60;
                const replaceData = data.replace(SIGN_TEXT, img.outerHTML);
                setDefaultValue(replaceData);
              }
            });
          } else {
            setDefaultValue(data);
          }
        })
        .catch(() => {
          setHtml("");
        });
    }
  }, [mode, type, history, signBase64]);

  useEffect(() => {
    setHtml(defaultValue);
  }, [defaultValue]);

  const handleOnChangeEditor = (content) => {
    setHtml(content);
  };


  const handleOnChangeSunEditor = (content) => {
    setHtml(content.target.value);
  };

  const submit = () => {
    const body = {
      type,
      targetEmployeeIdx: _target.idx,
      title,
      html,
      startTime: form.date[0],
      endTime: form.date[1],
    };

    systemAlert(`${_target.title}님에게 계약 요청하시겠습니까?`, {
      buttons: [
        {
          color: "text",
          label: "취소",
        },
        {
          label: "승인",
          onClick: () => {
            createContracts(body).then(() => {
              dispatch(contractListReload());
              dispatch(getStoreEmployees());
              // window.location.reload()
              _close();
            });
          },
        },
      ],
    });
  };

  const { form, setForm, errors, handleOnChange, handleSubmit } = useForm(
    {
      date: [getDay(7), getDay()],
    },
    submit
  );

  const _close = (e) => {
    close(e);
  };

  const handleSign = () => {
    setSignEmployeeOpen(true);
  };

  return (
    <>
      <div className="contract-contents">
        <div className="contract-header-wrap print-out">
          {mode === "create" && (
            <h2 className="contract-title">{_target.title}님에게 계약요청</h2>
          )}
          {mode === "detail" && !isEmpty(target) && (
            <>
              <h2 className="contract-title">{`${target.name}님의 ${!isEmpty(title) ? title : translation(
                CONTRACT_TYPE,
                type,
                "type",
                "label"
              )}`}</h2>
              {!isEmpty(contract) && (
                <Badge
                  label={contract.isSigned ? "서명완료" : "서명 대기중"}
                  color={contract.isSigned ? "secondary" : "success"}
                />
              )}
              <Button
                label="인쇄"
                color="gray-line"
                onClick={() => window.print()}
                className="print-button"
              />
            </>
          )}
        </div>
        <div className="contract-form-wrap">
          <Form
            fields={fields}
            form={form}
            onChange={handleOnChange}
            errors={errors}
          />
          {
            isOldEditor ?
              <Editor
                value={html}
                defaultValue={defaultValue}
                onChange={handleOnChangeEditor}
                readOnly={mode === "detail"}
                style={{ height: "500px", marginBottom: "50px" }}
              />
              :
              !isEmpty(html) && (
                <SunEditor
                  value={html}
                  onChange={handleOnChangeSunEditor}
                  readOnly={mode === "detail"}
                />
              )
          }


        </div>
        <div className="print-out">
          {mode === "create" && (
            <div className="contact-content-button-wrap">
              <Button onClick={close} color={"text"}>
                취소
              </Button>
              <Button onClick={handleSubmit}>계약요청</Button>
            </div>
          )}
          {mode === "detail" && (
            <div className="contact-content-button-wrap">
              <Button onClick={close} color={"text"}>
                취소
              </Button>
              {!isSigned &&
                !isEmpty(target) &&
                me.employeeIdx === target.idx && (
                  <Button onClick={handleSign}>서명하기</Button>
                )}
            </div>
          )}
        </div>
      </div>
      {signEmployeeOpen && (
        <ContractSign
          open={signEmployeeOpen}
          setOpen={setSignEmployeeOpen}
          submit={_submit}
          html={defaultValue}
          target={target}
          contractIdx={contractIdx}
          contractClose={_close}
        />
      )}
    </>
  );
};

export default Contract;
